import { ISocialNetworkActionPayload } from '../interfaces/social-network.action-payload.interface';

export class AddSocialNetwork {
    static readonly type = '[User] AddSocialNetwork';

    constructor(public payload: ISocialNetworkActionPayload) {}
}
